module.exports = __webpack_public_path__ + "img/adv_data.d9e55229.png";